import type { Ref } from 'vue';
import { computed } from 'vue';

import type { IContextQueryResult } from '@modules/core/services/query/types';
import {
  AFFILIATES_APPROVED_FIXED_PAYMENTS_PERMISSIONS,
} from '@modules/affiliates-approved/submodules/trackers-settings/submodules/trackers-list/submodules/fixed-tracker-payments/constants';
import { useRestClient } from '@modules/core/services/api';
import { useContextQuery } from '@modules/core/services/query';

import type { IFixedPaymentsHistoryChangesItemResponse } from '../types';
import { FIXED_TRACKER_PAYMENTS_HISTORY_CHANGES_ITEM_API_URL, FIXED_TRACKER_PAYMENTS_HISTORY_CHANGES_ITEM_QUERY } from '../constants';

export default function useFixedPaymentsHistoryItemQuery(id: Ref<number>, merchantId: Ref<number>): IContextQueryResult<
  IFixedPaymentsHistoryChangesItemResponse
> {
  const { fetchGet } = useRestClient();

  return useContextQuery<IFixedPaymentsHistoryChangesItemResponse>({
    queryKey: [FIXED_TRACKER_PAYMENTS_HISTORY_CHANGES_ITEM_QUERY, id],
    queryFn: ({ signal }) => fetchGet<IFixedPaymentsHistoryChangesItemResponse>(
      FIXED_TRACKER_PAYMENTS_HISTORY_CHANGES_ITEM_API_URL,
      {
        signal,
        permission: AFFILIATES_APPROVED_FIXED_PAYMENTS_PERMISSIONS.HISTORY_CHANGES_EDIT,
        urlParams: {
          itemId: id.value,
        },
        queryParams: { merchant: merchantId.value },
      },
    ),
    enabled: computed(() => !!id.value),
  });
}
